import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiTextfieldControllerModule, TuiLabelModule } from "@taiga-ui/core";
import { TuiTextAreaModule } from "@taiga-ui/kit";
import { KwikUITextareaComponent } from "./textarea.component";

@NgModule({
  declarations: [KwikUITextareaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiTextAreaModule,
    TuiTextfieldControllerModule,
    TuiLabelModule
  ],
  exports: [KwikUITextareaComponent]
})
export class KwikUITextareaModule {}
